import Vue from 'vue'
import VueRouter from 'vue-router'
import GeneInfoView from '../views/Home/Info/GeneInfo.vue'

const GeneDetailsView = () => import('../views/Gene/Details/GeneDetails.vue')
const GeneBlastView = () => import('../views/Blast/GeneBlast.vue')

const DownloadView = () => import('../views/Download/DownloadView.vue')
const AboutView = () => import('../views/About/AboutView.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/home'
    
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: 'Home page of swidatabase',
      keeyAlive: true
    },
    component: GeneInfoView
  },
  {
    path: '/gene',
    name: 'gene',
    meta: {
      keepAlive: true
    },
    component: GeneDetailsView,
  },
  {
    path: '/blast',
    name: 'blast',
    meta: {
      keepAlive: true
    },
    component: GeneBlastView,
  },
  {
    path: '/download',
    name: 'download',
    meta: {
      keepAlive: true
    },
    component: DownloadView
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      keepAlive: true
    },
    component: AboutView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes
})

export default router
